import React from 'react'
import image from '../assets/img/no-page.png'

const NotFound = () => {
    return (
        <div className="min-h-screen flex flex-col items-center justify-center bg-white text-white">
            <div className="text-center">
                {/* Add the GIF here */}
                <img
                    src={image} // Replace with your GIF URL
                    alt="Coming Soon Animation"
                    className=" mx-auto"
                    style={{ maxWidth: '300px' }}
                />
                <h1 className="text-6xl font-bold mb-4 text-gray-900">
                    Coming Soon
                </h1>
                <p className="text-xl mb-8 text-gray-600">
                    We're working hard to bring you something amazing. Stay tuned!
                </p>
                <div className="flex justify-center space-x-4">
                   
                    <a
                        href="/dashboard"
                        className="px-6 py-2 border border-primary-600 text-primary-600 font-semibold rounded-md hover:bg-blue-600 hover:text-white transition duration-300"
                    >
                        Learn More
                    </a>
                </div>
            </div>
        </div>
    );
}

export default NotFound